import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import CardContainer from '../../components/CardContainer'
import { searchCountries, searchContinents } from '../../sources/SearchSource'
import {
  updateCountry,
  deleteCountry,
  createCountry
} from '../../sources/AdminSource'
import { translate } from 'react-i18next'
import Grid from 'grid-styled'
import ThemeContainer from '../../components/ThemeContainer'
import AdminNavbar from '../../components/AdminNavbar'
import { Metrics, Fonts, Colors } from '../../Themes'
import BackArrow from '../../svg-icons/BackArrow'
import Edit from '../../svg-icons/Edit'
import Add from '../../svg-icons/Add'
import SearchableDropdown from '../../components/SearchableDropdown'
import UploadPicture from '../../components/UploadPicture'
import TextArea from '../../components/Textarea'
import Input from '../../components/Input'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'
import DialogModal from '../../components/Modal/DialogModal'
import { countryDefault } from '../../Utils/Defaults'

const Container = styled.div`
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const BackArrowContainer = styled.div`
  margin: ${Metrics.margins.base} 0;
  cursor: pointer;
  span {
    margin-left: ${Metrics.margins.base};
    ${Fonts.style.Header};
  }
`

const Picture = styled.div`
  height: 136px;
  width: 136px;
  background: ${props =>
    props.imageSrc
      ? `url('${props.imageSrc}') no-repeat center`
      : Colors.lightGrey};
  background-size: cover;
  position: relative;
`

const EditIcon = styled.div`
  background: ${Colors.lightGrey};
  width: 40px;
  height: 40px;
  position: absolute;
  cursor: pointer;
  right: -${Metrics.margins.base};
  bottom: -${Metrics.margins.base};
  border-radius: 50%;
  svg {
    margin: 8px;
    #icon-outline {
      fill: ${Colors.white};
    }
  }

  &:hover {
    background: ${Colors.darkGrey};
  }
`

const ImportPicture = styled.div`
  ${Fonts.style.Text};
  color: ${Colors.white};
  margin: 0 auto;
  text-align: center;
  padding: ${Metrics.margins.larger};
  cursor: pointer;

  svg {
    margin: 0 auto;
    margin-bottom: ${Metrics.margins.medium};
    display: block;
    #plus-icon {
      fill: ${Colors.white};
    }
  }
`

const FormTitle = styled.div`
  ${Fonts.style.Label};
  margin-bottom: ${Metrics.margins.small};
`

const CustomGrid = styled(Grid)`
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.small)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.small)};
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding: 0 32px !important; 
`

const Error = styled.div`
  ${Fonts.style.Input};
  margin-top: ${Metrics.margins.tiny};
  color: ${Colors.red};
`

class EditPictures extends Component {
  constructor (props) {
    super(props)
    this.state = {
      country: R.clone(countryDefault),
      continents: [],
      continentName: '',
      imageError: '',
      modal: '',
      create: false
    }
    this.handleUpload = this.handleUpload.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleDeleteCountry = this.handleDeleteCountry.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.handleError = this.handleError.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleSearchContinent = this.handleSearchContinent.bind(this)
  }

  componentWillMount () {
    const { params } = this.props
    if (params.id !== 'new') {
      searchCountries({ id: params.id })
        .then(response =>
          this.setState({
            country: response.data,
            continentName: response.data.continent.name
          })
        )
        .catch(error => console.log(error))
    } else {
      this.setState({ create: true })
    }
  }

  handleUpload (file, result) {
    const { country } = this.state
    country.picture = { file: file, result: result }
    this.setState({ country, imageError: null })
  }

  handleUpdate () {
    const { country, create } = this.state
    if (create) {
      createCountry(country)
        .then(response => {
          let countryCreated = response.data[0] || response.data
          this.setState({ country: countryCreated, modal: 'success' })
        })
        .catch(error => {
          console.log(error)
          this.setState({ modal: 'error' })
        })
    } else {
      updateCountry(country)
        .then(response => {
          this.setState({ country: response.data, modal: 'success' })
        })
        .catch(error => {
          console.log(error)
          this.setState({ modal: 'error' })
        })
    }
  }

  handleSearchContinent (event) {
    this.setState({ continentName: event.target.value }, () => {
      searchContinents({
        where: { name: { startsWith: this.state.continentName } }
      })
        .then(response => this.setState({ continents: response.data }))
        .catch(error => console.log(error))
    })
  }

  handleDeleteCountry () {
    deleteCountry(this.state.country.id)
      .then(response => this.props.router.goBack())
      .catch(error => {
        console.log(error)
        this.setState({ modal: 'error' })
      })
  }

  handleChange (event, key) {
    const { country } = this.state
    country[key] = event.target.value
    this.setState({ country })
  }

  handleSelect (el) {
    const { country } = this.state
    country.continent = el
    this.setState({ country, continentName: el.name })
  }

  toggleModal (modal) {
    this.setState({ modal })
  }

  handleError () {
    const { t } = this.props
    this.setState({
      imageError: t('Image too large (2MB max) or has an invalid type')
    })
  }

  render () {
    const { t, router, admin, dropdownLinks } = this.props
    const {
      country,
      modal,
      imageError,
      create,
      continentName,
      continents
    } = this.state
    const adminActions = [
      { label: t('Save'), secondary: true, onClick: this.handleUpdate }
    ]
    if (!create) {
      adminActions.push({
        label: t('Delete Country'),
        cancel: true,
        onClick: () => this.toggleModal('dialog')
      })
    }
    return (
      <div>
        <AdminNavbar
          admin={admin}
          dropdownLinks={dropdownLinks}
          fixedSearchBar
          rightSideActions={adminActions}
        />
        <SuccessModal
          visible={modal === 'success'}
          message={t(`Country successfuly ${create ? 'created' : 'updated'}.`)}
          header={t(`Country ${create ? 'Created' : 'Updated'}`)}
          closeAction={this.toggleModal}
        />
        <ErrorModal
          visible={modal === 'error'}
          message={t(
            `There was a problem when ${create
              ? 'creating'
              : 'updating'} the country.`
          )}
          header={t('Error')}
          closeAction={this.toggleModal}
        />
        <DialogModal
          visible={modal === 'dialog'}
          message={t('Do you want to delete this country?')}
          header={t('Delete Country')}
          closeAction={this.toggleModal}
          buttons={{
            apply: {
              label: 'Cancel',
              onClick: this.toggleModal
            },
            cancel: {
              label: 'Delete',
              onClick: this.handleDeleteCountry
            }
          }}
        />
        <Container>
          {country && (
            <CustomThemeContainer>
              <BackArrowContainer>
                <BackArrow onClick={() => router.goBack()} />
                <span className='name'>
                  {create ? t('Insert Country') : country.name}
                </span>
              </BackArrowContainer>
              <CustomCardContainer
                title={create ? t('Create New Country') : t('Edit Country')}>
                <CustomGrid noPadTop noPadLeft noPadRight>
                  <Input
                    value={country.name}
                    title={t('Country')}
                    handleChange={event => this.handleChange(event, 'name')}
                    placeholder={t('Country Name')}
                  />
                </CustomGrid>
                <CustomGrid noPadLeft noPadRight>
                  <CustomGrid xs={1 / 3} noPadLeft noPadTop>
                    <FormTitle>{t('Continent')}</FormTitle>
                    <SearchableDropdown
                      value={continentName}
                      handleSelect={this.handleSelect}
                      handleSearch={this.handleSearchContinent}
                      placeholder={t('Continent name')}
                      options={continents}
                      accessor={d => d.name}
                    />
                  </CustomGrid>
                  <CustomGrid noPadLeft noPadRight>
                    <TextArea
                      title={t('Description')}
                      value={country.description}
                      handleChange={event =>
                        this.handleChange(event, 'description')}
                      placeholder={t('Country description')}
                    />
                  </CustomGrid>
                </CustomGrid>
                <CustomGrid noPadLeft noPadRight>
                  <Picture
                    imageSrc={
                      (country.picture && country.picture.result) ||
                      country.picture
                    }>
                    <UploadPicture
                      uploadButton={
                        country.picture ? (
                          <EditIcon>
                            <Edit />
                          </EditIcon>
                        ) : (
                          <ImportPicture>
                            <Add />
                            {t('Import Picture')}
                          </ImportPicture>
                        )
                      }
                      handleError={this.handleError}
                      handleUploaded={this.handleUpload}
                    />
                  </Picture>
                  {imageError && <Error>{imageError}</Error>}
                </CustomGrid>
              </CustomCardContainer>
            </CustomThemeContainer>
          )}
        </Container>
      </div>
    )
  }
}

EditPictures.propTypes = {
  router: PropTypes.object,
  params: PropTypes.object,
  t: PropTypes.func,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin' ], { wait: true })(EditPictures)



// WEBPACK FOOTER //
// ./src/pages/AdminLocations/EditCountry.js